import { CUSTOM_EVENTS } from '../constants'
import {
  ATTENTIVE_EMAIL_SUBMIT_EVENT_KEY,
  ATTENTIVE_POPUP_VIEW_EVENT,
} from '@src/quince-site-common/src/utils/addAttentiveSDK/addAttentiveSdk.constants'
import { trackEvent } from '@src/telemetry/track'
import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'

const handleDlChange = (data: any) => {
  const eventData = (data?.detail || [])[0]

  if (eventData?.creative_id) {
    if (eventData.event === ATTENTIVE_POPUP_VIEW_EVENT) {
      trackEvent(TELEMETRY_EVENT_NAMES.FORM_OPEN, {
        action: 'attentive_popup_opened',
        context: {
          creative_id: eventData.creative_id,
        },
      })
    }
    if (eventData.event === ATTENTIVE_EMAIL_SUBMIT_EVENT_KEY) {
      trackEvent(TELEMETRY_EVENT_NAMES.BUTTON_CLICK, {
        action: 'attentive_email_submitted',
        context: {
          creativeId: eventData.creative_id,
          gender: eventData.attentive_gender,
        },
      })
    }
  }
}

export function attentiveSdkDlListener() {
  document.addEventListener(CUSTOM_EVENTS.DATA_LAYER_CHANGE, handleDlChange)
}

export function removeSdkDlListener() {
  document.removeEventListener(CUSTOM_EVENTS.DATA_LAYER_CHANGE, handleDlChange)
}
